import request from '../kernel/request'

export default {
    subject:{
        list(params) {
            return request.get('subject', params)
        },
        listClass(params) {
            return request.get('subject/list/class', params)
        },
        save(data) {
            return request.post('subject', data)
        },
        update(data) {
            return request.put('subject', data)
        },
        load(id) {
            return request.get('subject/' + id)
        },
        delete(id) {
            return request.delete('subject/' + id)
        }
    },
    subjectConfig:{
        list(params) {
            return request.get('subjectConfig', params)
        },
        listAll(params) {
            return request.get('subjectConfig/list', params)
        },
        page(params) {
            return request.get('subjectConfig/page', params)
        },
        pageBy(params) {
            return request.get('subjectConfig/by/course', params)
        },
        save(data) {
            return request.post('subjectConfig', data)
        },
        update(data) {
            return request.put('subjectConfig', data)
        },
        load(id) {
            return request.get('subjectConfig/' + id)
        },
        edit(id) {
            return request.get('subjectConfig/edit/' + id)
        },
        delete(id) {
            return request.delete('subjectConfig/' + id)
        }
    },
    courseSubject:{
        list(params) {
            return request.get('course/and/subject', params)
        },
        listAllBy(params) {
            return request.get('course/and/subject/list', params)
        },
        save(data) {
            return request.post('course/and/subject', data)
        },
        update(data) {
            return request.put('course/and/subject', data)
        },
        load(id) {
            return request.get('course/and/subject/' + id)
        },
        delete(id) {
            return request.delete('course/and/subject/' + id)
        }
    }
}